/* <scroll-fill-text>: splits its text into words and fills them in, one after another,
   as the element travels from `data-start`% to `data-end`% of the viewport height. */
(() => {
  if (customElements.get('scroll-fill-text')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ScrollFillText extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.wrapWords(this);
      this.words = Array.from(this.querySelectorAll('.statement__word'));
      this.start = (parseFloat(this.dataset.start) || 90) / 100;
      this.end = (parseFloat(this.dataset.end) || 40) / 100;
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      if (reduceMotion.matches) {
        this.words.forEach((w) => w.style.setProperty('--fill', 1));
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll);
            this.update();
          } else {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        });
      }, { rootMargin: '20% 0px' });
      this.observer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    // Wrap each word of every text node in a span, keeping inline tags (em, a, strong) intact.
    wrapWords(node) {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.ELEMENT_NODE) {
          this.wrapWords(child);
          return;
        }
        if (child.nodeType !== Node.TEXT_NODE || !child.textContent.trim()) return;
        const fragment = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement('span');
            span.className = 'statement__word';
            span.textContent = part;
            fragment.appendChild(span);
          }
        });
        child.replaceWith(fragment);
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      // 0 when the top of the text is at `start` of the viewport, 1 when its bottom reaches `end`.
      const from = vh * this.start;
      const to = vh * this.end;
      const span = Math.max(1, from - to + rect.height);
      const progress = Math.min(1, Math.max(0, (from - rect.top) / span));
      const count = this.words.length;
      const position = progress * count;
      this.words.forEach((word, i) => {
        const fill = Math.min(1, Math.max(0, position - i));
        word.style.setProperty('--fill', fill.toFixed(2));
      });
    }
  }

  customElements.define('scroll-fill-text', ScrollFillText);
})();
